import React from 'react';
import { Heart } from 'lucide-react';
import personalData from '../data/personal.json';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}>
          Made with <Heart size={16} style={{ color: '#ef4444', fill: '#ef4444' }} /> by {personalData.name}
        </p>
      </div>
    </footer>
  );
};

export default Footer;